import DocumentItem from './DocumentItem'; // To be created
import config from '../../../../config/config' // Assuming you have a config file for base URL

const EuNumberGroup = ({
  euNumber,
  documentsMap,
  allData,
  isExpanded,
  onToggleGroup,
  isSelected,
  onSelectChange,
  highlightsMap,
  loadingHighlights,
  highlightErrors,
  imageDataUriMap,
  onOpenImageModal,
  loadingGroupImages // Specific to this group if fetched on expand
}) => {

  const formatEuNumberDisplay = (num, data) => {
    const formatted = num.replace(/-/g, '/');
    if (!data || data.length === 0) return formatted;
    const item = data.find(i => i.eu_pnumber.replace(/-/g, '/') === formatted);
    return item ? `${formatted} - ${item.eu_brand_name_current} (${item.active_substance_current})` : formatted;
  };

  const groupTypeCounts = Object.values(documentsMap).reduce((acc, doc) => {
    if (doc.details && doc.details.file_type) {
      const ft = doc.details.file_type === 'Nan' ? 'other' : doc.details.file_type;
      acc[ft] = (acc[ft] || 0) + 1;
    } else if (doc.details) {
      acc['other'] = (acc['other'] || 0) + 1;
    }
    return acc;
  }, {});
  const groupTotalImages = Object.values(documentsMap).reduce((total, doc) => total + doc.images.length, 0);

  return (
    <div className="eu-number-group">
      <div className="eu-number-header" onClick={() => onToggleGroup(euNumber)}>
        <div className="eu-number-checkbox">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => { e.stopPropagation(); onSelectChange(euNumber, !isSelected); }}
            onClick={(e) => e.stopPropagation()}
          />
          <div className="eu-number-title">
            <i className={`bx ${isExpanded ? 'bx-chevron-down' : 'bx-chevron-right'}`}></i>
            <h3>{formatEuNumberDisplay(euNumber, allData)}</h3>
          </div>
        </div>
        <div className="document-type-indicators">
          {['epar', 'decision', 'annex', 'other'].map(type => (
            groupTypeCounts[type] > 0 ? (
              <div className="document-type-bubble" key={type}>
                <span className={`bubble-count bubble-count-${type}`}>{groupTypeCounts[type]}</span>
                <span className="bubble-label">{type}</span>
              </div>
            ) : null
          ))}
          {groupTotalImages > 0 && (
            <div className="document-type-bubble" key="image">
              <span className="bubble-count bubble-count-other">{groupTotalImages}</span>
              <span className="bubble-label">Images</span>
            </div>
          )}
          <a href={`${window.location.origin}${config.routes.main.details}/${euNumber.replace(/-/g, '_')}`} className="med-link" target="_blank" rel="noopener noreferrer">
          View page <i className="bx bx-link-external"></i>
          </a>
        </div>
      </div>
      {isExpanded && (
        <div className="eu-number-documents">
          {loadingGroupImages && <div className="group-images-loading"><i className='bx bx-loader-alt bx-spin'></i> Loading images for this group...</div>}
          {Object.entries(documentsMap).map(([docFilename, docGroup]) => (
            <DocumentItem
              key={docFilename}
              docFilename={docFilename}
              docGroup={docGroup}
              highlights={highlightsMap[docGroup.details?.original_pdf_filename || docGroup.details?.filename || docFilename] || []}
              isLoadingHighlights={loadingHighlights[docGroup.details?.original_pdf_filename || docGroup.details?.filename || docFilename]}
              highlightError={highlightErrors[docGroup.details?.original_pdf_filename || docGroup.details?.filename || docFilename]}
              imageDataUriMap={imageDataUriMap}
              onOpenImageModal={onOpenImageModal}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EuNumberGroup;